export const shortenAddress = (str = "", front = 6, back = 4) => {
  return str ? `${str.slice(0, front)}...${str.slice(str.length - back)}` : str;
};
